import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { SectionLabel } from "@/components/shared";
import { FadeUp } from "@/components/motion/Reveal";
import { getTestimonials } from "@/lib/api";

export default function Testimonials({ heading, label = "Voices", limit, showEmpty = false }) {
  const [items, setItems] = useState([]);
  useEffect(() => { getTestimonials().then(setItems).catch(() => setItems([])); }, []);
  const list = limit ? items.slice(0, limit) : items;

  if (!list.length && !showEmpty) return null;

  return (
    <section data-testid="testimonials-section" className="relative z-10 bg-[#0A0A0A] border-y border-white/10 py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 spotlight" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <SectionLabel>{label}</SectionLabel>
            <h2 className="mt-5 font-display uppercase text-5xl md:text-7xl leading-[0.9]">
              {heading || <>Pastors Who&apos;ve <span className="text-wutn">Hosted</span></>}
            </h2>
          </div>
        </div>

        {list.length === 0 ? (
          <p className="text-zinc-500">Testimonials will appear here as churches share their experience.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {list.map((t, i) => (
              <FadeUp key={t.id} delay={(i % 3) * 0.06}>
                <figure className="bg-black p-8 md:p-10 h-full flex flex-col" data-testid={`testimonial-${t.id}`}>
                  <Quote className="h-8 w-8 text-wutn" />
                  <blockquote className="mt-5 text-zinc-200 text-lg leading-relaxed flex-1">“{t.quote}”</blockquote>
                  <figcaption className="mt-8 pt-6 border-t border-white/10">
                    <div className="font-cond uppercase text-white">{t.author}</div>
                    <div className="text-xs uppercase tracking-widest text-wutn mt-1">
                      {[t.role, t.organization].filter(Boolean).join(" · ")}
                    </div>
                    {t.location && <div className="text-xs text-zinc-500 mt-1">{t.location}</div>}
                  </figcaption>
                </figure>
              </FadeUp>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
